import { useEffect } from 'react';
import axiosInstance from '../general/axiosInstance';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { logout } from '../general/actions';

const Logout = (props) => {
  const { isLoggedIn, logout } = props;
  const navigate = useNavigate();

  function closeSession() {
    axiosInstance.post('/logout')
      .catch(error => console.log(error))
      .finally(() => {
        logout();
        // Only UI-state keys live here now (no credentials); drop per-session ones.
        try { localStorage.removeItem('count_pending_approve'); localStorage.removeItem('selectedAgreement'); } catch (e) {}
        navigate('/login');
      });
  }

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      closeSession();
    }
  }, [isLoggedIn, navigate, closeSession]);

  return;
};

function mapStateToProps(state) {
  return {
    username: state.username,
    isLoggedIn: state.isLoggedIn
  };
}

const mapDispatchToProps = {
  logout
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
